import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestData } from 'src/app/common/models/request-data.model';
import { ComboModel } from '../model/combo.model';
import { ComboService } from '../combo.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, startWith, map } from 'rxjs';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';
import { AppConstants } from 'src/app/common/app.constants';
@Component({
  selector: 'app-combo-edit',
  templateUrl: './combo-edit.component.html',
  styleUrls: ['./combo-edit.component.scss'],
  standalone: false
})
export class ComboEditComponent implements DirtyCheck {
  title: string = "New Combo";
  editForm!: FormGroup;
  comboInfo: ComboModel = { comboOptionValues: [], is_active: 1 };
  isFormDirty: boolean = false;
  ratingList: ComboModel[] = [];
  context: any;
  departments: any;
  selectedDepartments: any[] = [];
  optionForList: any = [];
  comboOptionValues: any;
  defaultOptionId: any;
  saleItems: any[] = [];
  filteredSaleItems!: Observable<any[]>;
  // Add this property to track if sale items are already being loaded
  private loadingSaleItems = false;
  // Class property to store the promise for loading sale items
  private saleItemsLoadPromise: Promise<void> | null = null;
  filteredSaleItemsArray: any[][] = [];
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private comboService: ComboService, // Service for combo-related API calls
    private snackBarService: SnackBarService, // Service for displaying notification messages
    public dialog: MatDialog, private permissionService: PermissionService) { // Dialog service for modal dialogs
    this.permission = permissionService.getPagePermission("combo");
    // Get combo ID from route parameters
    let comboId = this.route.snapshot.paramMap.get('id');

    // Initialize the form regardless of whether it's a new or existing combo
    this.comboInfo = { comboOptionValues: [], is_active: 1 };

    // If editing existing combo, load its data
    if (comboId !== null && parseInt(comboId) !== 0) {
      // Load sale items first to ensure they're available
      this.loadSaleItems();
      this.setMenuInfo(comboId);

    }
    else {
      const comboData = history.state.comboData;
      // console.log('comboData:', history.state.comboData);
      if (comboData) {
        // Ensure saleItems are loaded before initializing the form
        this.loadSaleItems();
        this.initForm(comboData); // Use this data to pre-fill the form

      } else {
        // For new combo, initialize the form and load sale items
        this.loadSaleItems();
        this.title = this.getTitle();
        this.initForm();
        this.addOption();
        this.isFormDirty = false;
      }
    }

    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission('combo'), comboId);

  }

  /**
   * Initialize component data on init
   */
  ngOnInit(): void {
    // No need to call loadSaleItems() here as it's already called in the constructor

    // Only update column visibility if the form exists

    if (this.editForm) {
      this.updateDynamicColumnVisibility();
    }
  }

  /**
   * Loads sale items from the server for dropdown selection
   * Returns a promise that resolves when sale items are loaded
   */
  loadSaleItems() {
    const storedSaleItems = sessionStorage.getItem(AppConstants.SESSION_VAR_COMBO_SALE_ITEMS);
    if (storedSaleItems) {
      this.saleItems = JSON.parse(storedSaleItems);
    }
  }
  // loadSaleItems(): Promise<void> {
  //   // If we already have a promise, return it to avoid duplicate calls
  //   if (this.saleItemsLoadPromise) {
  //     console.log('Using existing sale items load promise');
  //     return this.saleItemsLoadPromise;
  //   }

  //   // If items are already loaded, return a resolved promise
  //   if (this.saleItems && this.saleItems.length > 0) {
  //     console.log('Sale items already loaded, using cached data');
  //     return Promise.resolve();
  //   }

  //   console.log('Creating new sale items load promise');

  //   // Create a new promise and store it
  //   this.saleItemsLoadPromise = new Promise((resolve) => {
  //     const requestData: RequestData = {
  //       search: {
  //         filters: {
  //           scope: {
  //             limit: 1000,
  //             offset: 0
  //           }
  //         },
  //         sort: [

  //         ]
  //       }
  //     };

  //     console.log('Making API call to load sale items');

  //     // Call API to get sale items
  //     this.comboService.getSaleItems(requestData).subscribe({
  //       next: (response: any) => {
  //         if (response.status === 'SUCCESS') {
  //           this.saleItems = response.data.items;
  //           // Sort sale items by name in ascending order
  //           this.saleItems.sort((a, b) => a.name.localeCompare(b.name));
  //           console.log('Sale items loaded successfully:', this.saleItems.length);
  //         } else {
  //           console.error('Failed to load sale items:', response.message);
  //         }
  //         resolve(); // Resolve the promise regardless of success/failure
  //       },
  //       error: (error: any) => {
  //         console.error('API error when loading sale items:', error);
  //         resolve(); // Resolve the promise even on error
  //       }
  //     });
  //   });

  //   return this.saleItemsLoadPromise;
  // }

  /**
   * Determines which columns to display based on form values
   */
  updateDynamicColumnVisibility() {
    // Check if any option has price or quantity values
    const control = this.editForm?.get('comboOptionValues') as FormArray;
    if (control) {


    }
  }

  initForm(comboInfo?: ComboModel) {

    this.editForm = this.builder.group({
      code: this.builder.control(comboInfo?.code || '', [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(comboInfo?.name || '', [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(comboInfo?.description || ''),
      display_name: this.builder.control(comboInfo?.display_name || '', [Validators.required]),
      comboOptionValues: this.builder.array(comboInfo?.comboOptionValues?.map(opt => this.createOptionGroup(opt)) || [], [Validators.required, Validators.minLength(1)]), // initialize array
    });
    this.editForm.valueChanges.subscribe(() => {
      if (this.editForm.dirty) {
        this.isFormDirty = true;
      }
    });
    this.editForm.get('comboOptionValues')?.valueChanges.subscribe(() => {
      this.updateDynamicColumnVisibility();
    });
    this.filteredSaleItems = this.editForm.get('sale_item')?.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSaleItems(value || ''))
    ) || of([]);
  }

  get options(): FormArray {
    return this.editForm.get('comboOptionValues') as FormArray;
  }

  createOptionGroup(opt: any) {
    const price = Number(opt.price) || 0;
    const priceVariance = Number(opt.price_variance) || 0;
    const discPrice = (price - priceVariance).toFixed(2);

    let saleItem = null;
    if (opt.sale_item && typeof opt.sale_item === 'object') {
      saleItem = opt.sale_item;
    } else if (opt.sale_item_id && Number(opt.sale_item_id) > 0) {
      const saleItemId = Number(opt.sale_item_id);
      saleItem = this.saleItems.find(item => item.id === saleItemId) || null;
    }

    const group = this.builder.group({
      id: [opt.id],
      sale_item: [saleItem, [Validators.required, this.saleItemValidator]],
      name: [opt.name, Validators.required],
      def_qty: [{ value: opt.def_qty !== undefined ? Number(opt.def_qty) : 1, disabled: true }, [Validators.required, Validators.min(1)]],
      price: [{ value: price, disabled: true }],
      is_percentage: [Number(opt.is_percentage)],
      price_variance: [priceVariance],
      disc_price: [{ value: discPrice, disabled: true }],
      is_default: [Number(opt.is_default)],
      display_order: [opt.display_order, [Validators.required, Validators.min(0)]]
    }, { validators: this.negativeDiscPriceValidator });
    // Update disc_price whenever price or price_variance changes
    group.get('price')?.valueChanges.subscribe(() => {
      this.updateDiscPrice(group);
    });
    group.get('price_variance')?.valueChanges.subscribe(() => {
      this.updateDiscPrice(group);
    });
    group.get('is_percentage')?.valueChanges.subscribe(() => {
      this.updateDiscPrice(group);
    });

    return group;
  }

  addOption() {
    const optionGroup = this.builder.group({
      id: [0],
      name: ['', Validators.required],
      price_variance: [''],
      disc_price: [{ value: '', disabled: true }],
      sale_item: [null as any, [Validators.required, this.saleItemValidator]],
      def_qty: [1, [Validators.required, Validators.min(1)]],
      price: [''],
      is_percentage: [false],
      is_default: [true],
      display_order: [1, [Validators.required, Validators.min(0)]]
    }, { validators: this.negativeDiscPriceValidator });

    const index = this.options.length;
    // Initialize filtered list for the new row, excluding items already selected in other rows
    const selectedIds = this.options.controls
      .map(group => group.get('sale_item')?.value?.id || null)
      .filter(id => id !== null);

    this.filteredSaleItemsArray[index] = this.saleItems.filter(item => !selectedIds.includes(item.id));

    optionGroup.get('sale_item')?.valueChanges.subscribe((value: any) => {
      if (value && typeof value !== 'string') {
        const priceControl = optionGroup.get('price');
        if (typeof value === 'object' && value && 'id' in value) {
          this.updatePriceFromSaleItem(optionGroup, value.id);
          priceControl?.disable();
        } else {
          priceControl?.enable();
          priceControl?.setValue('');
        }
        this.updateDynamicColumnVisibility();
      }
    });

    // Subscribe to quantity changes and update price if sale_item is selected
    optionGroup.get('def_qty')?.valueChanges.subscribe((qty: any) => {
      const saleItem = optionGroup.get('sale_item')?.value;
      if (saleItem && typeof saleItem === 'object' && saleItem.id) {
        this.updatePriceFromSaleItem(optionGroup, saleItem.id);
      }
    });

    // After creating optionGroup
    optionGroup.get('price')?.valueChanges.subscribe(() => {
      this.updateDiscPrice(optionGroup);
    });
    optionGroup.get('price_variance')?.valueChanges.subscribe(() => {
      this.updateDiscPrice(optionGroup);
    });
    optionGroup.get('is_percentage')?.valueChanges.subscribe(() => {
      this.updateDiscPrice(optionGroup);
    });

    this.options.push(optionGroup);
    this.isFormDirty = true;

    // Automatically smoothly scroll to the newly appended row
    setTimeout(() => {
      const element = document.getElementById('row-' + index);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  removeOption(index: number) {
    if (this.options.length > 1) {
      this.options.removeAt(index);
      this.isFormDirty = true;
    } else {
      let snackBarData: SnackBarData = {
        message: 'At least one combo option is required.',
        title: 'Minimum Required',
        type: 'error'
      }
      this.snackBarService.openSnackBar(snackBarData);
    }
  }

  onEnter(event: any) {
    event.preventDefault();
  }
  setDefault(index: number) {
    this.options.controls.forEach((group, i) => {
      group.get('is_default')?.setValue(i === index);
      group.get('is_default')?.markAsDirty();
    });
    this.isFormDirty = true;
  }
  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/product/combo']);

  }

  /**
   * If tas is is null set an empty menu info
   * if menu id is not null call api to retrive the info
   * @param menuId 
   */
  setMenuInfo(menuId: any): void {
    this.comboService.getComboById(menuId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.comboInfo = response.data.combo;
          this.comboOptionValues = response.data.combo_option_value;
          this.title = this.getTitle();
          this.initForm(this.comboInfo);
          // Set existing options - sale items should already be loaded
          this.setExistingOptions(this.comboOptionValues || []);

          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }
  setExistingOptions(options: any[]) {
    const formArray = this.editForm.get('comboOptionValues') as FormArray;
    formArray.clear(); // Clear any existing items to avoid duplicates

    options.forEach((opt, index) => {
      // Initialize filtered list for the row, excluding items already selected in other rows
      const selectedIds = options
        .filter((_, idx) => idx !== index)
        .map(otherOpt => Number(otherOpt.sale_item_id))
        .filter(id => id > 0);

      this.filteredSaleItemsArray[index] = this.saleItems.filter(item => !selectedIds.includes(item.id));

      // Create the form group
      const optionGroup = this.builder.group({
        id: [opt.id],
        name: [opt.name, Validators.required],
        price_variance: [opt.price_variance],
        disc_price: [opt.disc_price],
        sale_item: [null as any, [Validators.required, this.saleItemValidator]],
        def_qty: [opt.def_qty],
        price: [opt.price],
        is_percentage: [this.toBoolean(opt.is_percentage)],
        is_default: [this.toBoolean(opt.is_default)],
        display_order: [opt.display_order, Validators.required]
      }, { validators: this.negativeDiscPriceValidator });

      // Set disc_price initially based on price and price_variance
      this.updateDiscPrice(optionGroup);

      // Subscribe to value changes immediately
      optionGroup.get('price')?.valueChanges.subscribe(() => {
        this.updateDiscPrice(optionGroup);
      });
      optionGroup.get('price_variance')?.valueChanges.subscribe(() => {
        this.updateDiscPrice(optionGroup);
      });
      optionGroup.get('is_percentage')?.valueChanges.subscribe(() => {
        this.updateDiscPrice(optionGroup);
      });

      // If a sale item is selected, find the object and set it
      if (opt.sale_item_id && Number(opt.sale_item_id) > 0) {
        const saleItemId = Number(opt.sale_item_id);
        const saleItem = this.saleItems.find(item => item.id === saleItemId);
        if (saleItem) {
          optionGroup.get('sale_item')?.setValue(saleItem);
          this.updatePriceFromSaleItem(optionGroup, saleItemId);
          optionGroup.get('price')?.disable();
        } else {
          // If we can't find it in the list, fetch it
          // this.comboService.getSaleItemById(saleItemId).subscribe({
          //   next: (response: any) => {
          //     if (response.status === 'SUCCESS' && response.data.sale_item) {
          //       const item = response.data.sale_item;
          //       optionGroup.get('sale_item')?.setValue(item);
          //       optionGroup.get('price')?.setValue(item.fixed_price);
          //       optionGroup.get('price')?.disable();
          //     }
          //   }
          // });
        }
      }

      // Handle value changes
      optionGroup.get('sale_item')?.valueChanges.subscribe((value: any) => {
        // Only handle non-string values here (objects)
        if (value && typeof value !== 'string') {
          const priceControl = optionGroup.get('price');
          if (typeof value === 'object' && value && 'id' in value) {
            this.updatePriceFromSaleItem(optionGroup, value.id);
            priceControl?.disable();
          } else {
            priceControl?.enable();
            priceControl?.setValue('');
          }
          this.updateDynamicColumnVisibility();
        }
      });

      // Subscribe to quantity changes and update price if sale_item is selected
      optionGroup.get('def_qty')?.valueChanges.subscribe((qty: any) => {
        const saleItem = optionGroup.get('sale_item')?.value;
        if (saleItem && typeof saleItem === 'object' && saleItem.id) {
          this.updatePriceFromSaleItem(optionGroup, saleItem.id);
        }
      });

      formArray.push(optionGroup);
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.comboInfo.id == 0 || this.comboInfo.id == undefined) ? "New Combo" : "Editing : " + this.comboInfo.name;
    return title;
  }
  onDepartmentCheckboxChange(event: any, department: any, index: number) {
    if (event.checked) {
      // Add if not already present
      if (!this.selectedDepartments.find(dep => dep.id === department.id)) {
        this.selectedDepartments.push(department);
      }
    } else {
      // Remove unchecked
      this.selectedDepartments = this.selectedDepartments.filter(dep => dep.id !== department.id);
    }
    this.isFormDirty = true;
    // console.log('Selected Departments:', this.selectedDepartments);
  }
  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {
    const optionsArray = this.editForm.get('comboOptionValues') as FormArray;

    if (this.editForm.valid && optionsArray.length > 0) {
      // Check for negative discount prices manually as well
      const hasNegativeDisc = optionsArray.controls.some(ctrl => {
        const price = Number(ctrl.get('price')?.value) || 0;
        const variance = Number(ctrl.get('price_variance')?.value) || 0;
        const isPerc = ctrl.get('is_percentage')?.value;
        const discPrice = this.toBoolean(isPerc) ? (price - (price * (variance / 100))) : (price - variance);
        return discPrice < 0;
      });

      if (hasNegativeDisc) {
        let snackBarData: SnackBarData = {
          message: 'Discount price cannot be negative. Please check variance values.',
          title: 'Validation Error',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
        return;
      }
      // Get form values including disabled controls
      const formValues = this.editForm.getRawValue();

      // Process comboOptionValues to include sale_item_id
      const processedOptions = optionsArray.controls.map((control: AbstractControl) => {
        const formGroup = control as FormGroup;
        // Get values including disabled controls
        const optionData = formGroup.getRawValue();

        // Add sale_item_id property with the value from sale_item
        optionData.sale_item = optionData.sale_item && optionData.sale_item.id ? optionData.sale_item.id : null;

        // Ensure price is included (it might be disabled)
        if (optionData.price === undefined || optionData.price === null) {
          // If price is somehow missing, try to get it directly from the control
          const priceControl = formGroup.get('price');
          if (priceControl) {
            optionData.price = priceControl.value;
          }
        }

        return optionData;
      });

      // Update the comboInfo object with processed options
      this.comboInfo = {
        ...this.comboInfo,
        ...formValues,
        comboOptionValues: processedOptions
      };

      this.comboService.update(this.comboInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.comboInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/product/combo']);
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    } else {
      if (optionsArray.length === 0) {
        let snackBarData: SnackBarData = {
          message: 'At least one combo option is required before saving.',
          title: 'Validation Error',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      } else {
        // Check if the reason for invalidity is a negative discount price
        const hasNegativeDisc = optionsArray.controls.some(ctrl => ctrl.hasError('negativeDiscPrice'));

        let snackBarData: SnackBarData = {
          message: hasNegativeDisc
            ? 'Discount price cannot be negative. Please check variance values.'
            : 'Please fill all required fields correctly.',
          title: 'Validation Error',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.editForm.markAllAsTouched();
    }
  }

  private _filterSaleItems(value: any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.saleItems.filter(item =>
      item.name.toLowerCase().includes(filterValue)
    );
  }

  displaySaleItem(saleItemId: number): string {
    if (saleItemId === 0) return 'Select';
    const item = this.saleItems.find(item => item.id === saleItemId);
    return item ? item.name : '';
  }

  // New method to update the total price based on quantity
  updateTotalPrice(formGroup: FormGroup, quantity: any) {
    const saleItemId = formGroup.get('sale_item')?.value;
    const basePrice = formGroup.get('price')?.value;

    if (!quantity || quantity <= 0 || !basePrice) {
      return;
    }

    // If there's a sale item selected, get its base price
    if (saleItemId && saleItemId > 0) {
      const saleItem = this.saleItems.find(item => item.id === saleItemId);
      if (saleItem) {
        const itemPrice = Number(saleItem.fixed_price ?? saleItem.shop_price ?? saleItem.price ?? 0);
        const totalPrice = itemPrice * quantity;
        // Update the price field with the calculated total
        formGroup.get('price')?.setValue(totalPrice);
      }
    } else if (basePrice) {
      // If there's no sale item but there is a base price, calculate based on that
      const numericBasePrice = parseFloat(basePrice);
      if (!isNaN(numericBasePrice)) {
        const totalPrice = numericBasePrice * quantity;
        formGroup.get('price')?.setValue(totalPrice);
      }
    }
  }

  // Add this new method to fetch and set the price from a sale item
  updatePriceFromSaleItem(formGroup: FormGroup, saleItemId: number): void {
    const saleItem = this.saleItems.find(item => item.id === saleItemId);
    const quantity = Number(formGroup.get('def_qty')?.value) || 1;
    if (saleItem) {
      const itemPrice = Number(saleItem.fixed_price ?? saleItem.shop_price ?? saleItem.price ?? 0);
      const price = (itemPrice * quantity).toFixed(2);
      formGroup.get('price')?.setValue(price);
    } else {
      this.comboService.getSaleItemById(saleItemId).subscribe({
        next: (response: any) => {
          if (response.status === 'SUCCESS' && response.data.sale_item) {
            const fetchedItem = response.data.sale_item;
            const itemPrice = Number(fetchedItem.fixed_price ?? fetchedItem.shop_price ?? fetchedItem.price ?? 0);
            const price = (itemPrice * quantity).toFixed(2);
            formGroup.get('price')?.setValue(price);
          }
        }
      });
    }
  }

  /**
   * Filters sale items based on input for a specific row
   * @param index The index of the option in the form array
   */
  filterSaleItems(index: number): void {
    const control = this.options.at(index);
    const searchValue = control.get('sale_item')?.value;

    // ✅ Get IDs that are already selected in OTHER rows
    const selectedIds = this.options.controls
      .map((group, idx) => {
        if (idx === index) return null; // Don't exclude the item selected in the CURRENT row
        const val = group.get('sale_item')?.value;
        return (val && typeof val === 'object') ? val.id : null;
      })
      .filter(id => id !== null);

    const filterValue = (typeof searchValue === 'string') ? searchValue.toLowerCase() : '';

    // Filter by name and exclude selected IDs
    this.filteredSaleItemsArray[index] = this.saleItems.filter(item =>
      item.name.toLowerCase().includes(filterValue) && !selectedIds.includes(item.id)
    );
  }

  /**
   * Clears the selected sale item for a specific row
   * @param index The index of the option in the form array
   */
  clearSaleItem(index: number): void {
    const control = this.options.at(index);
    control.get('sale_item')?.setValue(null);
    control.get('price')?.setValue('');
    control.get('price')?.enable();
    this.updateDynamicColumnVisibility();
  }

  /**
   * Handles the selection of a sale item from the autocomplete
   * @param event The selection event
   * @param index The index of the option in the form array
   */
  onSaleItemSelected(event: any, index: number): void {
    const selectedItem = event.option.value;
    const control = this.options.at(index);

    // Update the form control with the selected item
    control.get('sale_item')?.setValue(selectedItem);
    this.isFormDirty = true;

    // Update price from the selected sale item
    if (selectedItem && selectedItem.id) {
      this.updatePriceFromSaleItem(control as FormGroup, selectedItem.id);
      control.get('price')?.disable();

      // Also update name fields if they're empty
      const nameControl = control.get('name');
      const nameToPrintControl = control.get('disc_price');

      if (!nameControl?.value) {
        nameControl?.setValue(selectedItem.name);
      }

      if (!nameToPrintControl?.value) {
        nameToPrintControl?.setValue(selectedItem.name);
      }
    }

    this.updateDynamicColumnVisibility();
  }

  /**
   * Display function for the autocomplete
   * @param item The sale item to display
   * @returns The display name
   */
  displaySaleItemName(item: any): string {
    return item ? item.name : '';
  }

  // Add this function to your component class
  saleItemValidator = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return { required: true };
    // If value is an object (selected from autocomplete), it's valid
    if (typeof value === 'object' && value.id) return null;
    // If value is a string, check if it matches any sale item name
    const match = this.saleItems.some(item => item.name.toLowerCase() === value.toLowerCase());
    return match ? null : { invalidSaleItem: true };
  };

  getDefaultIndex(): number {
    return this.options.controls.findIndex(ctrl => ctrl.get('is_default')?.value);
  }

  updateDiscPrice(optionGroup: FormGroup) {
    const price = Number(optionGroup.get('price')?.value) || 0;
    const priceVariance = Number(optionGroup.get('price_variance')?.value) || 0;
    const isPercentage = optionGroup.get('is_percentage')?.value;

    let discPrice: number;

    if (this.toBoolean(isPercentage)) {
      // If percentage, calculate (priceVariance)% of price, and subtract it
      // Rule: if variance > 100%, discPrice will naturally be negative
      const discountAmount = price * (priceVariance / 100);
      discPrice = price - discountAmount;
    } else {
      // Direct subtraction
      // Rule: if variance > price, discPrice will naturally be negative
      discPrice = price - priceVariance;
    }

    optionGroup.get('disc_price')?.setValue(discPrice.toFixed(2), { emitEvent: false });
  }

  // Add this method to your component:
  toBoolean(val: any): boolean {
    return val === true || val === 1 || val === '1' || val === 'true';
  }

  negativeDiscPriceValidator = (group: AbstractControl): { [key: string]: any } | null => {
    const price = Number(group.get('price')?.value) || 0;
    const variance = Number(group.get('price_variance')?.value) || 0;
    const isPerc = group.get('is_percentage')?.value;

    let discPrice: number;
    if (this.toBoolean(isPerc)) {
      discPrice = price - (price * (variance / 100));
    } else {
      discPrice = price - variance;
    }

    return discPrice < 0 ? { negativeDiscPrice: true } : null;
  };
}

